// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610012104/js/" + chunkId + "." + {"44":"bbb75268","225":"55cc6c71","481":"0be809d0","486":"959be0ea","770":"90896d28"}[chunkId] + ".0.6642802679236604.chunk.js";
};